import { createAction, ActionType } from 'typesafe-actions';
import { GetUserInfoReponse } from '../../lib/api/types/GetUserInfoReponse';
export const UserActions = {
    userInfoReceived: createAction('user/USER_INFO_RECEIVED')<GetUserInfoReponse>(),
    logOnOff: createAction('user/LOG_ON_OFF')<boolean>(),
    isLoggedOn: createAction('user/IS_LOGGED_ON')<boolean>(),
};
export type UserActions = ActionType<typeof UserActions>;
